import Color from 'colorjs.io';
import {css, html, nothing} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import './packery.js';

import './activities';
import './activity';
import './activity-log-entry';
import './activity-option';
import './activity-queue';
import './activity-queue-item';
import {ActivityQueueItem} from './activity-queue-item';
import './actor';
import './batch';
import './batches';
import './creature-editor';
import './dev-tools';
import './filter-entry';
import './filter-view';
import './help-icon';
import './landmark';
import './landmarks';
import './log';
import './map';
import './modal';
import './panel';
import './perceptions-minigame';
import './plot';
import './resource';
import './resources';
import './resources-delta';
import './settings';
import './smooth-value';
import './speed-controls';
import './spell';
import './spells';
import './stat';
import './stats';
import './status-effect';
import './tutorial';
import './unlockables';
import './unlockables-entry';

import 'draggabilly';
import {__, compose, divide, equals, not, product} from 'ramda';
import {
  animationFrames,
  BehaviorSubject,
  buffer,
  bufferCount,
  combineLatest,
  distinct,
  distinctUntilKeyChanged,
  filter,
  first,
  from,
  interval,
  map,
  NEVER,
  Observable,
  pairwise,
  scan,
  share,
  skipWhile,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';
import {Activity} from './activity';
import {ActivityLogEntry} from './activity-log-entry';
import {Actor, Entity} from './actor';
import {Batch} from './batch';
import Decimal, {DecimalSource} from './break_infinity.js';
import {gameLoop} from './gameLoop';
import './global';
import global_css from './global-css';
import './htmlelement-tag-name-map';
import {activityNames, initializeActivities} from './initializeActivities';
import {initializeLandmarks, landmarkNames} from './initializeLandmarks';
import {initializeResources, resourceNames} from './initializeResources';
import {initializeSpells, spellNames} from './initializeSpells';
import {initializeStats, statNames} from './initializeStats';
import {Cost} from './interfaces/dynamic-value';
import {Filterable} from './interfaces/filterable';
import {Named} from './interfaces/named.js';
import {IValuable} from './interfaces/valuable';
import {Landmark, Positionable} from './landmark';
import {LogEntry} from './log';
import {MapPanel} from './map';
import {Panel} from './panel';
import {setClickMeStartDate} from './perceptions-minigame';
import {Resource} from './resource';
import {RxLitElement} from './rx-lit-element.js';
import settings, {Settings} from './settings';
import {setupP5} from './setupP5';
import {Spawner} from './spawner';
import {Spell} from './spell';
import {Stat} from './stat';
import {StatusEffect} from './status-effect';
import {
  ActivityLogEntrySaveData,
  ActivityName,
  Gettable,
  LogEntrySaveData,
  PanelID,
  ResourceName,
  SaveGame,
  SpellName,
  StatName,
} from './types/runner-idle.js';
import {UnlockableLitElement} from './unlockable-lit-element';
import {
  any$,
  euclideanDistance,
  getScrollbarWidth,
  mergeDeep,
  roundToSteps,
  typedFromEntries,
} from './utils';
import {ValuefulUnlockableLitElement} from './valueful-unlockable-lit-element';
import {Vector} from './Vector';
import {Creature} from './creature';
import {
  deerTemplate,
  duckTemplate,
  goblinMageTemplate,
  goblinTemplate,
  grueTemplate,
  makeZombieTemplate,
  shadowTemplate,
  slimeBossTemplate,
  slimeTemplate,
  squirrelTemplate,
  witherBossTemplate,
} from './creature_templates';
import tutorial from './tutorial';
import * as D from './decimal_utils';

export const Draggabilly = window.Draggabilly; //HACK
export type Draggabilly = typeof Draggabilly;
export const p5 = window.p5; //HACK
export type p5 = typeof p5;

let saveGame: SaveGame = JSON.parse(localStorage.getItem('saveGame') || 'null');
const saveVersion = 17;

export const tickLength = 1000;
let lastSpellCooldownTime = Date.now();

// HACK I know. This is gross.
export const ri = document.querySelector('runner-idle') as RunnerIdle;
// HACK Temporary stuff to help with dev.
window.ri = ri;
window.Decimal = Decimal;
window.TAU = Math.PI * 2;

export const TAU = Math.PI * 2;

export const MAX_ACTORS = 500;

export const updateSpellCooldowns = (dt: number) => {
  // Realtime spells are updated in a separate loop (see spells.ts)
  for (const spell of Object.values(ri.spells).filter(
    (spell) => !spell.tags.has('realtime')
  )) {
    if (spell.currentCooldown.gt(0)) {
      spell.currentCooldown = spell.currentCooldown.minus(dt / 1000);
    }
  }
};
let timeBudget = 0;
let completedAndRemovedRepeats = 0;
/** This is extremely cursed. Gotta change the model. */
export const performActivityFromQueue = (
  deltaTimeMs: number,
  queueContainer: {
    log(msg: string, tags?: string[]): void;
    activityQueue: ActivityQueueItem[];
    activityQueueIndex: number;
    activeActivity: Activity | null;
    lastCompletedActivity: Activity | null;
  },
  atStart: () => void
) => {
  timeBudget += deltaTimeMs / 1000;
  let performed = false;
  // console.log('search for activity to perform', timeBudget, deltaTimeMs);
  while (timeBudget > 0) {
    // Get the current activity
    const activityQueue = queueContainer.activityQueue;
    let queueItem = activityQueue[queueContainer.activityQueueIndex];
    const nextQueueItem = () => {
      completedAndRemovedRepeats = 0;
      queueContainer.activityQueueIndex =
        (queueContainer.activityQueueIndex + 1) % activityQueue.length;
      if (queueItem) {
        queueItem.active = false;
      }
      queueItem = activityQueue[queueContainer.activityQueueIndex];
      queueItem.active = true;
      queueItem.activeIndex = 0;
      checkAtStart();
    };
    const checkAtStart = () => {
      // Restart queueLoopDelta tracking if we're at the beginning
      if (
        queueContainer.activityQueueIndex == 0 &&
        (queueItem.activeIndex == 0 || queueItem.activeIndex == 1)
      ) {
        queueContainer.log('<strong>Start of Queue</strong>');
        atStart();
      }
    };
    // check if it's out of repeats
    while (
      !queueItem ||
      (queueItem.activeIndex > 0 &&
        queueItem.activeIndex >=
          queueItem.totalRepeat + completedAndRemovedRepeats) ||
      queueItem.repeat == 0
    ) {
      // if so, move to the next one
      nextQueueItem();
    }
    queueContainer.activeActivity = queueItem.activity as Activity;

    // checkAtStart();

    /* Perform the active Activity */
    // TODO Clean this whole thing up

    // First, get the current step the activity is on
    const step =
      (queueItem.activeIndex + 1) %
        (queueItem.activity.duration +
          completedAndRemovedRepeats * queueItem.activity.duration) || 0;
    // Try to perform it
    performed = queueContainer.activeActivity.perform(
      step,
      queueItem.optionIndex,
      queueItem.configuration
    );
    if (performed) {
      queueItem.activeIndex += 1;
      timeBudget -= Math.min(queueItem.activity.duration, 1);
      // If we're not always repeating the activity, reduce the number to repeats
      if (
        step == 0 &&
        !queueContainer.activityQueue[queueContainer.activityQueueIndex]
          .repeatActivity
      ) {
        queueContainer.activityQueue[
          queueContainer.activityQueueIndex
        ].repeat -= 1;
        completedAndRemovedRepeats += 1;
      }
    } else {
      nextQueueItem();
    }
  }
  return performed;
};

let insertedCSS = false;
export function updateUnlocks() {
  ri.unlockables.forEach((u) => u.tryUnlock());
}

export function save() {
  console.log('%cSaving', 'color: blue');
  // TEMP TODO
  if (!ri.readyToSave) return;
  /* Copy all save data to saveGame*/
  localStorage.setItem('saveGame', JSON.stringify(ri));
  const panels = {};
  if (!ri.panels || ri.panels.length == 0) {
    ri.panels = [
      ...(ri.shadowRoot?.querySelectorAll(`#masonry-root > *`) ?? []),
    ] as Panel[];
  }
  for (const panel of ri.panels) {
    if (!(panel instanceof Panel)) continue;
    const {width, height, top, left} = panel.style;
    panels[panel.id] = {
      width,
      height,
      top,
      left,
      pinned: panel.classList.contains('pinned'),
    };
  }
  localStorage.setItem('panels', JSON.stringify(panels));
}

/**
 * The top element for thisrunnerIdle.
 * Holds overarching gamestate and coordinates everything.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('runner-idle')
export class RunnerIdle extends RxLitElement implements Positionable {
  lastTime: Decimal = new Decimal(0);
  // #region Properties (84)
  /** Independently track what UnlockableEntries (by name of Unlockable) have been seen, to mark them not new upon load. */
  seenEntries: Set<string> = new Set();

  #panels: Map<PanelID, Panel> = new Map();
  #position: Vector = new Vector();

  public static override styles = [
    global_css,
    css`
      :host {
        overflow: scroll;
        background-color: rgb(var(--background-color));
      }

      #masonry-root {
        display: grid;
        grid-template-columns: repeat(auto-fit, 100px);
        height: calc(100vh - ${getScrollbarWidth()}px) !important;
        width: calc(100vw - ${getScrollbarWidth()}px) !important;
        background-color: rgb(var(--background-color));
      }
      #masonry-root.paused,
      #masonry-root.paused:focus {
        outline: 1rem red solid;
        outline-offset: -1rem;
      }

      #masonry-root > * {
        border: 2px #0002 solid;
        padding: 8px;
        background: #8fdaff;
        box-sizing: border-box;
        z-index: 1;
        overflow: hidden;
        resize: both;
      }
      #masonry-root > .pinned {
        z-index: 2;
        border: 2px #0008 solid;
      }
      #masonry-root > .minimized {
        overflow-y: hidden;
        min-height: 3rem;
        height: 5% !important;
      }
      #masonry-root > .is-dragging {
        z-index: 9999;
      }
      #masonry-root > .packery-drop-placeholder {
        z-index: 0;
        outline: 3px dashed #0002;
        outline-offset: -3px;
      }

      #queue-loop-delta.container {
        overflow-y: auto;
      }

      .ri-loop-delta {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        background-color: rgb(var(--value-color), 0.2);
      }

      .ri-loop-delta-label {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 40%;
      }

      .distance-display {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      .distance-display > * {
        white-space: nowrap;
      }

      .distance-display progress {
        width: 100%;
        height: 32px;
      }

      .distance-display progress::-webkit-progress-value {
        background-color: rbg(var(--value-color, green));
      }

      #activity-queue.drag-hover {
        background: #0002;
      }

      #activity-queue-container activity-queue-item {
        margin: 4px;
      }

      #batch-name-input {
        width: 18ch;
      }

      #speed-select {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .speed-select-item {
        border: 1px solid black;
        border-radius: 4px;
        margin: 2px;
        padding: 2px 4px;
      }

      .speed-select-item.selected {
        background: #0004;
      }

      #stats-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
      #stats-container > * {
        margin: 2px;
      }
      input.position-input {
        width: 12ch;
      }
    `,
  ];

  @property({type: Number}) public beforeBatchLoadoutIndex = -1;
  panels: Panel[] = [];
  map!: MapPanel;
  gridSize: number;

  public get kills(): Record<string, number> {
    return this.kills$.value;
  }
  public set kills(value: Record<string, number>) {
    this.kills$.next(value);
  }
  kills$: BehaviorSubject<Record<string, number>> = new BehaviorSubject({});
  public activeActivity: Activity | null = null;
  public activities!: Record<Exclude<ActivityName, SpellName>, Activity>;
  public activityQueue$: BehaviorSubject<ActivityQueueItem[]> =
    new BehaviorSubject([] as ActivityQueueItem[]);
  public activityQueueIndex$: BehaviorSubject<number> = new BehaviorSubject(0);
  /** How far away from the player should Actor's act() ? */
  public actorActiveRange = 1500;
  /** A stream of all Actors currently in the scene. */
  actors$: BehaviorSubject<Actor[]> = new BehaviorSubject([] as Actor[]);
  animationFrame$: Observable<{timestamp: number; elapsed: number}>;
  public batches: Record<string, Batch> = {};
  public defaultPanels = {
    'speed-controls': {
      pinned: true,
      width: '30%',
      height: '10%',
      top: '0%',
      left: '0%',
    },
    stats: {
      pinned: true,
      width: '30%',
      height: '20%',
      top: '50%',
      left: '70%',
    },
    'resources-delta': {
      pinned: true,
      width: '30%',
      height: '20%',
      top: '70%',
      left: '70%',
    },
    landmarks: {
      pinned: true,
      width: '40%',
      height: '20%',
      top: '0%',
      left: '30%',
    },
    map: {
      pinned: true,
      width: '40%',
      height: '50%',
      top: '20%',
      left: '30%',
    },
    'activity-queue': {
      pinned: true,
      width: '30%',
      height: '20%',
      top: '10%',
      left: '0%',
    },
    activities: {
      pinned: true,
      width: '30%',
      height: '20%',
      top: '30%',
      left: '0%',
    },
    resources: {
      pinned: true,
      width: '30%',
      height: '40%',
      top: '30%',
      left: '70%',
    },
    log: {
      pinned: true,
      width: '40%',
      height: '30%',
      top: '70%',
      left: '30%',
    },
    batches: {
      pinned: true,
      width: '10%',
      height: '10%',
      top: '90%',
      left: '0%',
    },
    unlockables: {
      pinned: true,
      width: '30%',
      height: '30%',
      top: '0%',
      left: '70%',
    },
    spells: {
      pinned: true,
      width: '30%',
      height: '20%',
      top: '50%',
      left: '0%',
    },
    'creature-editor': {
      pinned: true,
      width: '30%',
      height: '10%',
      top: '90%',
      left: '70%',
    },
    dev: {
      pinned: true,
      width: '30%',
      height: '10%',
      top: '90%',
      left: '70%',
    },
    'panel-management': {
      pinned: true,
      width: '20%',
      height: '10%',
      top: '90%',
      left: '10%',
    },
  };
  public distance$: BehaviorSubject<Decimal> = new BehaviorSubject(
    new Decimal(0)
  );
  public editingBatch: Batch | null = null;
  public finishedLoading = false;
  public focusPanels: Set<Panel> = new Set();
  public gameSpeed$: BehaviorSubject<number> = new BehaviorSubject(1);
  hunting$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public inSettings = false;
  public isClicking = false;
  public isDev = false && ['localhost'].includes(location.hostname);
  public isDev$: BehaviorSubject<boolean> = new BehaviorSubject(
    false && ['localhost'].includes(location.hostname)
  );
  public isDragging = false;
  public landmarks: Record<string, Landmark> = {};
  public lastCompletedActivity: Activity | null = null;
  public lastDarkMode = false;
  public lastDistance: DecimalSource = 0;
  public lastGameSpeed: number | null = null;
  public lastLightEffects = true;
  public lastLightValue = new Decimal(NaN);
  public lastLoadoutIndex = 0;
  public lastPositions: Vector[] = [] as Vector[];
  public lastQueueLoopDelta: Record<
    string,
    Filterable & {
      value: Decimal;
      capacity?: Decimal;
      unlocked?: boolean;
    }
  > = {};
  public lastResources: Record<string, {value: Decimal; capacity: Decimal}> =
    {};
  public lastStats: Record<string, {value: Decimal}> = {};
  public life = 0;
  public loaded = false;
  public loadouts: ActivityQueueItem[][] = [[], [], [], [], []];
  logEntries$: BehaviorSubject<LogEntry[]> = new BehaviorSubject(
    [] as LogEntry[]
  );
  public mapInitialized = false;
  masonry?: Packery;
  masonryOptions?: Partial<PackeryOptions>;
  masonryRoot?: HTMLElement;
  public override name = 'player';
  public newGame = false;
  /** The currently selected Landmark in the Destination panel. */
  nextLandmark?: Landmark;
  overlay!: typeof p5;
  p5!: typeof p5;
  position$: BehaviorSubject<Vector> = new BehaviorSubject(new Vector(0, 0, 0));
  drawPosition$!: Observable<Vector>;
  drawPosition: Vector = new Vector();
  logString = '';
  public settings = {
    darkMode:
      window.matchMedia('(prefers-color-scheme: dark)').matches ?? false,
    showCostEffectDetails: true,
    lightEffects: true,
    // disablePerceptionMinigame: false,
    scrollLogToNew: false,
    resources: {
      expandOrTooltip: true,
      keepExpandedAndAutoExpand: false,
      expandOnHover: true,
    },
    queue: {
      showProgressBars: true,
      showRepeatToggles: true,
      smallRepeatToggles: true,
    },
    map: {
      showPlayerTrail: true,
      showPlayerVelocityLine: true,
      showRegionNames: true,
      gridStrength: {min: 0, max: 5, value: 1},
      forceTargetOntoGrid: true,
      showSpawners: false,
      showActorNames: true,
      actorNameScale: {min: 1, max: 5, value: 1.5},
      showLandmarkLabels: true,
      landmarkLabelScale: {min: 1, max: 5, value: 1.5},
      // labelsOnCompleted: true,
      // invertColors: false,
    },
  };
  /** Should this save? */
  public readyToSave = false;
  public resources!: Record<ResourceName, Resource>;
  public spells!: Record<SpellName, Spell>;
  public stats!: Record<StatName, Stat>;
  public statusEffects: StatusEffect[] = [
    // StatusEffect.create(confusionTemplate()),
    // StatusEffect.create(makeRegenerationTemplate()),
    // StatusEffect.create(poisonTemplate()),
  ];
  public steppingOneFrame = false;
  targetPositions$: BehaviorSubject<Vector[]> = new BehaviorSubject([
    new Vector(),
  ]);
  public tick$: BehaviorSubject<Decimal> = new BehaviorSubject(new Decimal(0));
  public unlockedPanels = new Set<string>();
  public useSavedTime$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  // }
  /** How far away can the player see? */
  public visionRange: Decimal = new Decimal(0);

  public get activityQueue(): ActivityQueueItem[] {
    return this.activityQueue$.value;
  }

  public set activityQueue(value: ActivityQueueItem[]) {
    this.activityQueue$.next(value);
  }

  /** The change in Resources and Stats over the last Activity Queue loop. */
  public get activityQueueDelta() {
    // TEMP TODO
    // return {};
    if (
      Object.keys(this.lastResources).length == 0 ||
      Object.keys(this.lastStats).length == 0
    ) {
      return {};
    }
    const resourceDelta = Object.fromEntries(
      Object.values(this.resources).reduce(
        (acc: [string, object][], resource: Resource) => {
          const value = resource.value.minus(
            this.lastResources[resource.name].value
          );
          const perSecond = value.div(this.tick.minus(ri.lastTime));

          return acc.concat([
            [
              resource.name,
              {
                value,
                tags: resource.tags,
                capacity: resource.capacity.isFinite()
                  ? resource.capacity.minus(
                      this.lastResources[resource.name].capacity
                    )
                  : new Decimal(0),
                perSecond,
                timeToFullOrEmpty: () => new Decimal(0),
                // perSecond.gt(0)
                //   ? resource.vacancy$.value.isFinite()
                //     ? resource.vacancy.div(perSecond)
                //     : new Decimal(0)
                //   : perSecond.lt(0)
                //   ? resource.value.div(-perSecond)
                //   : new Decimal(0),
                unlocked: resource.unlocked,
              },
            ],
          ]);
        },
        []
      )
    );
    const statDelta = Object.fromEntries(
      Object.values(this.stats).reduce(
        (acc: [string, object][], stat: Stat) => {
          const value = stat.value.minus(this.lastStats[stat.name].value);
          const perSecond = value.div(this.tick.minus(ri.lastTime));
          return acc.concat([
            [
              stat.name,
              {
                value,
                tags: stat.tags,
                unlocked: stat.unlocked,
                perSecond,
              },
            ],
          ]);
        },
        []
      )
    );
    return {
      distance: {
        displayName: 'Distance',
        tags: new Set(['distance']),
        unlocked: true,
        value: this.distance.minus(this.lastDistance),
        perSecond: this.distance
          .minus(this.lastDistance)
          .div(this.tick.minus(ri.lastTime)),
      },
      ...resourceDelta,
      ...statDelta,
    };
  }

  public get activityQueueIndex() {
    return this.activityQueueIndex$.value;
  }

  public set activityQueueIndex(value) {
    this.activityQueueIndex$.next(value);
  }

  /** Backing prop for actors$ */
  public get actors(): Actor[] {
    return this.actors$.value;
  }

  public set actors(value: Actor[]) {
    this.actors$.next(value);
  }

  // /** The Landmark the player is currently at.active Expand to allow for areas?*/
  // public get currentLandmark(): Landmark | null {
  //   return (
  //     Object.values(this.landmarks).find((landmark) =>
  //       landmark.shape.contains(ri.position)
  //     ) ?? null
  //   );
  // }
  public get distance() {
    return this.distance$.value;
  }

  public set distance(value) {
    this.distance$.next(value);
  }

  public get gameSpeed(): number {
    return this.gameSpeed$.value;
  }

  public set gameSpeed(value: number) {
    this.gameSpeed$.next(value);
  }

  public get logEntries(): LogEntry[] {
    return this.logEntries$.value;
  }

  public set logEntries(value: LogEntry[]) {
    this.logEntries$.next(value);
  }

  public get position(): Vector {
    return this.position$.value;
  }

  public set position(value: Vector) {
    this.position$.next(value);
  }

  public get saveGame() {
    return saveGame;
  }

  public get targetPosition(): Vector {
    return this.targetPositions$.value[0] ?? this.position;
  }

  public set targetPosition(value: Vector) {
    this.targetPositions$.next([value]);
  }

  public get tick(): Decimal {
    return this.tick$.value;
  }

  public get unlockables(): UnlockableLitElement[] {
    return [
      ...Object.values(this.landmarks),
      ...Object.values(
        [
          ...((this.shadowRoot?.querySelectorAll(
            '#masonry-root > *'
          ) as NodeListOf<Panel>) ?? []),
        ].filter((el) => el instanceof Panel)
      ),
      ...Object.values(this.activities),
      ...Object.values(this.activities).flatMap((a) =>
        Object.values(a.optionsData)
      ),
      ...Object.values(this.resources),
      ...Object.values(this.stats),
      ...Object.values(this.spells),
      ...Object.values(this.spells).flatMap((s) =>
        Object.values(s.optionsData)
      ),
    ] as UnlockableLitElement[];
  }

  public get useSavedTime(): boolean {
    return this.useSavedTime$.value;
  }

  public set useSavedTime(value: boolean) {
    this.useSavedTime$.next(value);
  }

  // #endregion Properties (84)

  // #region Constructors (1)

  constructor() {
    super();
    this.animationFrame$ = animationFrames().pipe(share());
    setTimeout(this.focus.bind(this));
    this.activityQueue = this.loadouts[this.lastLoadoutIndex];
    this.init();

    if (saveGame == null) {
      ri.newGame = true;
    } else {
      this.load(saveGame);
    }

    this.drawPosition$ = combineLatest([
      this.animationFrame$,
      this.position$,
    ]).pipe(
      map(([_, position]) => position),
      pairwise(),
      scan((acc, [lastPosition, currentPosition]) => {
        if (lastPosition === currentPosition) {
          if (acc.z.lt(0)) return currentPosition;
          return acc.plus(currentPosition.minus(acc).times(0.1));
        }
        return lastPosition;
      }, new Vector(0, 0, -1))
    );
    this.subscribe('drawPosition', this.drawPosition$);

    const speedMap: Map<number, Observable<number>> = new Map([
      [1, interval(1000).pipe(map(() => 1000))],
      [2, interval(500).pipe(map(() => 500))],
    ]);
    // Feature unlocks. These must happen every time the game is loaded.
    any$(Object.values(ri.stats).map((stat) => stat.unlock$))
      .pipe(filter(Boolean), first())
      .subscribe(ri.unlockPerceptionMinigame);

    // Setup main game loop
    combineLatest([ri.gameSpeed$, ri.useSavedTime$, ri.resources.time.value$])
      .pipe(
        switchMap(([speed, useSavedTime, time]) => {
          if (speed === 0) {
            return combineLatest([
              this.animationFrame$,
              ri.stats.timeMagic.value$,
            ]).pipe(
              map(([{elapsed}, timeMagic]) => [elapsed, timeMagic]),
              pairwise(),
              map(
                ([[last], [current, timeMagic]]) =>
                  [(current as number) - (last as number), timeMagic] as [
                    number,
                    Decimal
                  ]
              ),
              map(
                ([dt, timeMagic]: [number, Decimal]) =>
                  (1 + timeMagic.plus(1).log2()) * dt
              )
            );
          }
          return useSavedTime && time.gt(0)
            ? this.animationFrame$.pipe(map((frame) => 1000))
            : speedMap.get(speed) ?? NEVER;
        }),
        takeUntil(this.disconnect$)
      )
      .subscribe(gameLoop);

    // Actor subscriptions
    combineLatest([ri.tick$, ri.actors$])
      .pipe(
        map(([tick, actors]) => [tick.floor(), actors]),
        distinct(([tick, actors]) => tick.toString()),
        map(([, actors]) =>
          actors.filter((actor) =>
            actor.position.distance(ri.position).lt(ri.actorActiveRange)
          )
        )
      )
      .subscribe((actors) => actors.forEach((actor) => actor.act()));

    this.subscribe(
      'visionRange',
      ri.stats.perception.value$.pipe(map((per) => per.plus(10)))
    );
    this.subscribe(
      'lastPositions',
      ri.position$.pipe(
        scan((acc, el) => acc.concat([el]).slice(-1000), [] as Vector[])
      )
    );

    setTimeout(() => {
      (
        this.shadowRoot?.querySelectorAll(
          '#masonry-root > *'
        ) as NodeListOf<Panel>
      ).forEach((el) => {
        el?.setup();
      });
    });

    // Setup position subscription to pop a targetPosition if we're on it
    combineLatest([this.position$, this.targetPositions$]).subscribe(
      ([position, targetPositions]) => {
        if (targetPositions.length === 0) return;
        if (position.eq(targetPositions[0])) {
          this.dequeueTargetPosition();
        }
      }
    );
  }

  // #endregion Constructors (1)

  // #region Public Methods (38)

  public RefreshMasonry() {
    if (!ri.masonryRoot) return;
    const horizontalStep = Math.round(ri.masonryRoot.offsetWidth / 10);
    const verticalStep = Math.round(ri.masonryRoot.offsetHeight / 10);
    ri.masonry = new Packery(ri.masonryRoot, {
      itemSelector: `#masonry-root > *:not(.pinned)`,
      columnWidth: horizontalStep,
      rowWidth: verticalStep,
      percentPosition: true,
    });
    for (const child of (ri.masonry?.element.children ?? []) as Iterable<
      Element & {draggie?: Draggabilly}
    >) {
      // @ts-expect-error: Draggabilly is weirdly typed // HACK
      child.draggie = new Draggabilly(child, {
        handle: child.shadowRoot?.querySelector('.drag-handle') ?? undefined,
        grid: [horizontalStep, verticalStep],
      });
      child.draggie?.on('dragStart', () => {
        ri.isDragging = true;
      });
      child.draggie?.on('dragEnd', () => {
        ri.isDragging = false;
        if (child.classList.contains('pinned')) ri.masonry?.layout();
      });
      ri.masonry?.bindDraggabillyEvents(child.draggie);
    }
    if (ri.loaded) {
      ri.unlockPanel('panel-management');
    }
  }

  public addActor(actor: Actor) {
    if (ri.actors.length < MAX_ACTORS) {
      this.actors.push(actor);
    }
  }

  public addStatusEffect(statusEffect: StatusEffect) {
    const existingEffect = this.statusEffects.find(
      (effect) => effect.displayName === statusEffect.displayName
    );
    if (existingEffect) {
      existingEffect.timeLeft = existingEffect.timeLeft
        .plus(statusEffect.timeLeft)
        .min(existingEffect.maxTimeLeft);
      existingEffect.stacks = existingEffect.stacks
        .plus(1)
        .min(existingEffect.maxStacks);
    } else {
      this.statusEffects.push(statusEffect);
    }
    try {
      ri.getPanel('activity-queue')?.requestUpdate();
    } catch (e) {
      console.error(e);
    }
  }

  public addToQueue(newActivityQueueItem: ActivityQueueItem) {
    ri.activityQueue$.next(
      ri.activityQueue$.value.concat([newActivityQueueItem])
    );
  }

  public atTargetPosition(): unknown {
    // todo streamify
    return euclideanDistance(this.position, this.targetPosition).eq(0);
  }

  public override connectedCallback() {
    super.connectedCallback();
    this.keyDown$.subscribe((e) => {
      e.stopPropagation();
      if (e.key === 'Escape') {
        if (ri.inSettings) {
          ri.inSettings = false;
          document.querySelector<Settings>('ri-settings')?.close();
        } else {
          ri.inSettings = true;
          settings();
        }
      }
    });
    this.keyPress$.subscribe((e) => e.stopPropagation());
    this.keyUp$.subscribe((e) => e.stopPropagation());
    this.resize$.subscribe(ri.RefreshMasonry);
  }

  public createBatchFromQueue(batchName = 'Batch') {
    const batch = document.createElement('ri-batch') as Batch;
    batch.initWithQueue(this.activityQueue);
    batch.name = batchName.replace(/\s/g, '_') as ActivityName;
    batch.displayName = batchName;
    this.batches[batch.name] = batch;
    ri.shadowRoot?.querySelector('ri-resources')?.packery?.addItems(batch);
  }

  public enqueueActivity(target: Activity) {
    const flattenBatch: (batch: Batch) => Activity[] = (batch: Batch) =>
      batch.activityQueue.flatMap((q) =>
        q.activity instanceof Batch
          ? [...flattenBatch(q.activity), q.activity]
          : q.activity
      );
    if (
      target instanceof Batch &&
      (target === ri.editingBatch ||
        (ri.editingBatch && flattenBatch(target).includes(ri.editingBatch)))
    ) {
      return;
    }
    const newActivityQueueItem = document.createElement(
      'ri-activity-queue-item'
    ) as ActivityQueueItem;
    if (target) {
      newActivityQueueItem.activity = target;
      newActivityQueueItem.option =
        newActivityQueueItem.activity.options[
          newActivityQueueItem.activity.optionIndex
        ];
      newActivityQueueItem.repeatActivity = target.repeatByDefault;
    }
    if (ri.lastGameSpeed) {
      ri.gameSpeed = ri.lastGameSpeed;
      ri.lastGameSpeed = null;
    }
    newActivityQueueItem.requestUpdate();
    ri.addToQueue(newActivityQueueItem);
    ri.requestUpdate();
  }

  public findClosestActor(name: string): Actor | null {
    return ri.actors
      .filter((actor) => actor.name === name)
      .reduce((acc, actor) => {
        if (
          acc.position
            .distance(ri.position)
            .lt(actor.position.distance(ri.position))
        ) {
          return acc;
        }
        return actor;
      });
  }

  public focusPanel(panel: Panel) {
    ri.focusPanels.delete(panel);
    ri.focusPanels.add(panel);
    let i = 3;
    ri.focusPanels.forEach((panel) => {
      panel.style.zIndex = `${i}`;
      i += 1;
    });
  }

  /**
   * Gain some amount of a thing.
   *
   * MUST be used for
   * distance,
   *
   * Can be used for
   * Resources,
   * Resources:capacity,
   * Stats,
   * but prefer ri.type.name.addValue(amount) style,
   * as looking stuff up is expensive
   *
   * @param name The thing to gain more of.
   * @param amount How much to gain.
   * @returns The new value of `name`.
   */
  public gain(name: Gettable, amount: DecimalSource) {
    if (name.slice(-9) == ':capacity') {
      const item = this.get(name.slice(0, -9) as ResourceName);
      if (!item)
        throw new Error(
          `${name} is not gettable, don't even think about its capacity.`
        );
      if (item.baseCapacity) {
        item.baseCapacity = item.baseCapacity.plus(amount);
        return item.baseCapacity;
      }
      // if (item.capacity) {
      //   item.capacity = item.capacity.plus(amount);
      //   return item.capacity;
      // }
      throw new Error(
        `${name} does not have a capacity property. Are you sure it's a Resource?`
      );
    }
    if (name.slice(-18) == ':capacityReduction') {
      const item = this.get(name.split(':')[0]);
      const tag = name.split(':')[1];
      if (!item) {
        throw new Error(
          `${name} is not gettable, don't even think about its capacity.`
        );
      }
      item.reduceCapacity(tag, amount);
      return;
      // if (item.capacity) {
      //   item.capacity = item.capacity.plus(amount);
      //   return item.capacity;
      // }
      throw new Error(
        `${name} does not have a capacity property. Are you sure it's a Resource?`
      );
    }
    if (name.slice(-6) == ':level') {
      const item = this.get(name.slice(0, -6) as ResourceName);
      if (!item)
        throw new Error(
          `${name} is not gettable, don't even think about its level.`
        );
      if (item.level) {
        item.level = item.level.plus(amount).max(1);
        return item.level;
      }
      throw new Error(
        `${name} does not have a level property. Are you sure it's a Resource?`
      );
    }
    const oldValue = this.get(name)?.baseValue;
    // Distance is special
    switch (name) {
      case 'distance':
        // Check to see if we're going anywhere
        if (this.targetPosition.notEquals(this.position)) {
          // How far and what direction?
          const {magnitude, normalized} = this.targetPosition.minus(
            this.position
          );
          if (magnitude.eq(0)) this.position = this.targetPosition;
          else if (![...normalized].some((factor) => factor.isNaN())) {
            // Let's go!
            const nextPosition = this.position.plus(
              ri.pointHasTag(ri.position, 'multiplySpeed')
                ? normalized.times(
                    new Decimal(amount)
                      .times(
                        Object.values(ri.landmarks)
                          .filter((l) => l.containsPoint(ri.position))
                          .reduce(
                            (acc, landmark) => acc.times(landmark.speed),
                            new Decimal(1)
                          )
                      )
                      .min(magnitude)
                  )
                : normalized.times(new Decimal(amount).min(magnitude))
            );
            const oldPosition = this.position;
            this.position = nextPosition;
            if (
              !ri.pointHasTag(nextPosition, 'passable') &&
              (ri.pointHasTag(nextPosition, 'water') ||
                ri.pointHasTag(nextPosition, 'wall'))
            ) {
              this.position = oldPosition;
            }
          }
        }
        this.nextLandmark?.tryUnlock();
        // TODO EXPENSIVE
        for (const activity of Object.values(this.activities)) {
          activity.requestUpdate();
        }
        break;
      case 'targetX':
        this.targetPosition = new Vector(amount, this.targetPosition.y);
        return;
      case 'targetY':
        this.targetPosition = new Vector(this.targetPosition.x, amount);
        return;
      case 'backgroundHue':
        this.setBackgroundHue(amount);
        break;
      default:
        break;
    }
    if (oldValue) {
      this.set(name, oldValue.plus(amount));
    }
    return this.get(name);
  }
  setBackgroundHue(amount: DecimalSource) {
    this.backgroundColor.hwb.h = new Decimal(amount).toNumber() % 255;
    setInterval(
      () => (this.backgroundColor = this.originalBackgroundColor.clone()),
      1000
    );
  }

  /**
   * Gets the current value (and more data) about various thing in the game.
   *
   * Can be used for
   * Resources,
   * Resources:capacity,
   * Stats,
   * distance,
   *
   * USE SPARINGLY. Expensive and unneeded except for dynamically retrieving values
   * where it could be one of many things.
   * Consider superclassing out "value" and related and doing this better.
   *
   * @param name The key or name of the thing to `get`. If it's unknown, will return `undefined`.
   * @returns An object describing the current state of the gotten thing. `undefined` if `name` was not found.
   */
  public get(name: ResourceName): Resource;
  public get(name: StatName): Stat;
  public get(name: 'distance'): {
    baseValue: Decimal;
    value: Decimal;
    displayName: string;
    unlocked: boolean;
  };
  public get(name: Gettable | string): IValuable | undefined;
  public get(name: Gettable | string): IValuable | undefined {
    if (name.slice(-9) == ':capacity') {
      const resourceName = name.slice(0, -9) as ResourceName;
      const item = this.get(resourceName);
      if (item === undefined) return undefined;
      return {
        ...item,
        value: item.value,
        baseCapacity: item.baseCapacity,
        capacity: item.capacity,
        displayName: `${item.displayName} capacity`,
        name,
        unlocked: item.unlocked,
        tags: item.tags,
      };
    }
    if (name.slice(-6) == ':level') {
      const resourceName = name.slice(0, -6) as ResourceName;
      const item = this.get(resourceName);
      if (item === undefined) return undefined;
      return {
        ...item,
        value: item.value,
        level: item.level,
        baseCapacity: item.baseCapacity,
        capacity: item.capacity,
        displayName: `${item.displayName} level`,
        name,
        unlocked: item.unlocked,
        tags: item.tags,
      };
    }
    if (name === 'distance')
      return {
        baseValue: this.distance,
        value: this.distance,
        displayName: 'Distance',
        unlocked: true,
      };
    if (name in this.resources) return this.resources[name as ResourceName];
    if (name in this.stats) return this.stats[name as StatName];
    return undefined;
  }

  public getActivityUsesByTag(tag: string) {
    return Object.values(this.activities)
      .filter((activity) => activity.tags.has(tag))
      .reduce((acc, activity) => acc.add(activity.uses$.value), new Decimal(0));
  }

  public getPanel(panelId: PanelID): Panel {
    let panel = this.#panels.get(panelId);
    if (panel) return panel;
    panel = this.shadowRoot?.getElementById(panelId) as Panel | undefined;
    if (!panel) throw new Error(`Can't find panel ${panelId}`);
    this.#panels.set(panelId, panel);
    return panel;
  }

  public init() {
    // First, fill up the various records that need to be initialized
    // with empty/initial objects, so that they can be referenced.
    ri.stats = typedFromEntries(
      statNames.map((name) => [name, document.createElement('ri-stat')])
    );
    ri.resources = typedFromEntries(
      resourceNames.map((name) => [name, document.createElement('ri-resource')])
    );
    ri.activities = typedFromEntries(
      activityNames.map((name) => [name, document.createElement('ri-activity')])
    );
    ri.spells = typedFromEntries(
      spellNames.map((name) => [name, document.createElement('ri-spell')])
    );
    ri.landmarks = typedFromEntries(
      landmarkNames.map((name) => [name, document.createElement('ri-landmark')])
    );

    // Order matters.
    // Things can only depend on things prior to them in the initialization sequence;
    // e.g. Resources cannot unlock based on Activity use, etc.
    // This is BAD. Major reason we did the condition() method before. Need to solve.
    initializeStats();
    initializeResources();
    initializeLandmarks();
    initializeActivities();
    initializeSpells();

    this.actors = [
      ...(Array(1)
        .fill({
          ...witherBossTemplate,
          position: new Vector(-2000, 500),
        })
        .map(Creature.create) as Creature[]),
      ...(Array(1)
        .fill({
          ...slimeBossTemplate,
          position: new Vector(400, 1100),
        })
        .map(Creature.create) as Creature[]),
      // ...(Array(1)
      //   .fill({
      //     ...makeZombieTemplate(slimeBossTemplate),
      //     position: new Vector(0, 1100),
      //   })
      //   .map(Creature.create) as Creature[]),
      // ...(Array(10).fill(slimeTemplate).map(Creature.create) as Creature[]),
      // ...(Array(10).fill(deerTemplate).map(Creature.create) as Creature[]),
      // ...(Array(10).fill(goblinTemplate).map(Creature.create) as Creature[]),
      // ...(Array(10)
      //   .fill(goblinMageTemplate)
      //   .map(Creature.create) as Creature[]),
      // ...(Array(5).fill(grueTemplate).map(Creature.create) as Creature[]),
      // ...(Array(5).fill(shadowTemplate).map(Creature.create) as Creature[]),
      // Spawner.create({
      //   name: 'Goblin Spawner',
      //   position: new Vector(100, 0),
      //   template: goblinTemplate,
      //   spawnRange: new Decimal(5),
      //   spawnInterval: new Decimal(10),
      // }),
      Spawner.create({
        name: 'squirrel1',
        displayName: 'Squirrel Spawn Zone',
        position: new Vector(500, 100),
        template: squirrelTemplate,
        maxChildren: new Decimal(30),
        spawnRange: new Decimal(200),
        spawnInterval: new Decimal(60),
      }),
      Spawner.create({
        name: 'deer1',
        displayName: 'Deer Spawn Zone',
        position: new Vector(500, 0),
        template: deerTemplate,
        maxChildren: new Decimal(10),
        spawnRange: new Decimal(200),
        spawnInterval: new Decimal(300),
      }),
    ];

    // combineLatest([interval(100), this.hunting$])
    //   .pipe(
    //     map(([, hunting]) => hunting),
    //     filter(identity)
    //   )
    //   .subscribe(() => ri.targetPosition$.next(ri.actors[0].position));

    this.nextLandmark = Object.values(this.landmarks)[0];
    for (const unlockable of this.unlockables) {
      // unlockable.setAttribute('hidden', '');
      // unlockable.setup();
      if (unlockable instanceof ValuefulUnlockableLitElement)
        unlockable.setInitials();
    }

    this.activityQueue = [];
    const restQueueItem = document.createElement(
      'ri-activity-queue-item'
    ) as ActivityQueueItem;
    restQueueItem.activity = this.activities.rest;
    restQueueItem.repeat = 1;
    const walkQueueItem = document.createElement(
      'ri-activity-queue-item'
    ) as ActivityQueueItem;
    walkQueueItem.activity = this.activities.walk;
    walkQueueItem.repeat = 1;
    this.activityQueue.push(restQueueItem);
    this.activityQueue.push(walkQueueItem);
    this.activityQueueIndex = 0;

    this.tabIndex = -1;
    this.addEventListener('keydown', (event) => {
      switch (event.code) {
        case 'Space':
          this.togglePause();
          break;
      }
      this.requestUpdate();
    });

    this.addEventListener('queue-item-split', (event) => {
      const originalQueueItem = event.composedPath()[0] as ActivityQueueItem;
      const copyQueueItem = document.createElement(
        'ri-activity-queue-item'
      ) as ActivityQueueItem;
      const queueItemIndex = this.activityQueue.findIndex(
        (queueItem) => queueItem == originalQueueItem
      );
      copyQueueItem.activity = originalQueueItem.activity;
      copyQueueItem.option = originalQueueItem.option;
      copyQueueItem.repeat = Math.max(
        Math.min(originalQueueItem.repeat, 1),
        Math.floor(originalQueueItem.repeat / 2)
      );
      originalQueueItem.repeat = Math.ceil(originalQueueItem.repeat / 2);
      this.activityQueue.splice(queueItemIndex + 1, 0, copyQueueItem);
      this.requestUpdate();
    });

    this.addEventListener('queue-item-deleted', (event) => {
      this.activityQueue$.next(
        this.activityQueue$.value.filter(
          compose(not, equals(event.composedPath()[0]))
        )
      );
      this.requestUpdate();
    });

    this.addEventListener('queue-item-reorder', (event) => {
      //todo fix to activityQueue$
      const e = event as CustomEvent;
      const oldIndex = e.detail.from;
      const newIndex = e.detail.to;

      const element = this.activityQueue.splice(oldIndex, 1)[0];
      this.activityQueue.splice(newIndex, 0, element);

      // check if the old item was active
      if (oldIndex == this.activityQueueIndex) {
        this.activityQueueIndex = oldIndex;
      }
      // check if the new location is active
      if (newIndex == this.activityQueueIndex) {
        this.activityQueueIndex = newIndex;
      }

      // splice is in-place, so manually request an update
      this.requestUpdate();
    });

    this.addEventListener('queue-item-earlier', (event) => {
      // original index for the clicked item
      const oldIndex = this.activityQueue.findIndex(
        (queueItem) => queueItem == event.composedPath()[0]
      );
      if (oldIndex == 0) return;
      // check if the item is active
      if (oldIndex == this.activityQueueIndex) {
        this.activityQueueIndex -= 1;
      }
      // check if the new location is active
      if (oldIndex == this.activityQueueIndex - 1) {
        this.activityQueueIndex += 1;
      }
      // Modulo, not remainder, so -1 flips to the end
      this.activityQueueIndex =
        ((this.activityQueueIndex % this.activityQueue.length) +
          this.activityQueue.length) %
        this.activityQueue.length;
      this.activityQueue.splice(oldIndex, 1);
      this.activityQueue.splice(
        oldIndex - 1,
        0,
        event.composedPath()[0] as ActivityQueueItem
      );
      this.requestUpdate();
    });

    this.addEventListener('queue-item-later', (event) => {
      const oldIndex = this.activityQueue.findIndex(
        (queueItem) => queueItem == event.composedPath()[0]
      );
      // check if the item is active
      if (oldIndex == this.activityQueueIndex) {
        this.activityQueueIndex += 1;
      }
      // check if the new location is active
      if (oldIndex == this.activityQueueIndex + 1) {
        this.activityQueueIndex -= 1;
      }
      // Modulo, not remainder, so -1 flips to the end
      this.activityQueueIndex =
        ((this.activityQueueIndex % this.activityQueue.length) +
          this.activityQueue.length) %
        this.activityQueue.length;
      this.activityQueue.splice(oldIndex, 1);
      this.activityQueue.splice(
        oldIndex + 1,
        0,
        event.composedPath()[0] as ActivityQueueItem
      );
      this.requestUpdate();
    });

    this.requestUpdate();
  }

  public enqueueTargetPosition(position: Vector) {
    this.targetPositions$.next(this.targetPositions$.value.concat([position]));
  }

  public dequeueTargetPosition() {
    this.targetPositions$.next(this.targetPositions$.value.slice(1));
  }

  public load(saveGame: SaveGame) {
    switch (saveGame.version) {
      case saveVersion: // Up to date!
        break;
      default: // Unknown? Leave early, wiping the save.
        ri.resetSave();
        return;
    }

    ri.lastTime = saveGame.lastTime;
    lastSpellCooldownTime = saveGame.lastSpellCooldownTime;
    this.life = saveGame.life;
    this.tick$.next(new Decimal(saveGame.tick));
    this.distance = new Decimal(saveGame.distance);
    this.unlockedPanels = new Set(saveGame.unlockedPanels);
    this.kills = saveGame.kills;
    this.logString = saveGame.logString;
    const resourcesFilters = saveGame.resourcesFilters;
    const activitiesFilters = saveGame.activitiesFilters;
    const spellsFilters = saveGame.spellsFilters;
    const unlockablesFilters = saveGame.unlockablesFilters;
    const logFilters = saveGame.logFilters;
    setTimeout(() => {
      const resources = ri.shadowRoot?.querySelector('ri-resources');
      if (resources) resources.filters = new Set(resourcesFilters);
      const activities = ri.shadowRoot?.querySelector('ri-activities');
      if (activities) activities.filters = new Set(activitiesFilters);
      const spells = ri.shadowRoot?.querySelector('ri-spells');
      if (spells) spells.filters = new Set(spellsFilters);
      const unlockables = ri.shadowRoot?.querySelector('ri-unlockables');
      if (unlockables) unlockables.filters = new Set(unlockablesFilters);
      const log = ri.shadowRoot?.querySelector('ri-log');
      if (log) log.filters = new Set(logFilters);
    });
    for (const landmarkData of saveGame.landmarks ?? []) {
      const landmark = ri.landmarks[landmarkData.name!];
      if (landmark?.temporary) {
        landmark.temporaryFinished$.next(
          landmarkData.visited && landmark.temporary
        );
      }
      landmark.visited$.next(landmarkData.visited);
      landmark.unlocked = landmarkData.unlocked;
    }
    ri.nextLandmark = Object.values(ri.landmarks).find(
      (landmark) => landmark.name === saveGame.nextLandmark
    );
    if (saveGame.targetPosition)
      ri.targetPosition = new Vector(
        ...saveGame.targetPosition.map((n) => new Decimal(n))
      );
    saveGame.resources.forEach((resourceData) =>
      this.resources[resourceData.name]?.loadFromJSON(resourceData)
    );
    saveGame.stats.forEach((statData) =>
      this.stats[statData.name]?.loadFromJSON(statData)
    );

    for (const activityData of saveGame.activities) {
      const activity = this.activities[activityData.name as ActivityName];
      if (activity) {
        activity.uses$.next(new Decimal(activityData.uses as Decimal));
        activity.successfulUses$.next(
          new Decimal(activityData.successfulUses as Decimal)
        );
        activity.consecutiveUses$.next(
          new Decimal(activityData.maxConsecutiveUses as Decimal)
        );
        activity.consecutiveUses$.next(new Decimal(new Decimal(0)));
        activity._canUseHere = activityData._canUseHere;
        activity.secret = activityData.secret;
        activity.new = activityData.new;
        activity.unlocked = activityData.unlocked;
        activity.toggleHiddenByPlayer(activityData.hiddenByPlayer);
        for (const optionData of activityData.optionsData ?? []) {
          if (optionData.name in activity.optionsData) {
            activity.optionsData[optionData.name].unlocked =
              optionData.unlocked;
            activity.optionsData[optionData.name].uses$.next(
              new Decimal(optionData.uses)
            );
            activity.optionsData[optionData.name].successfulUses$.next(
              new Decimal(optionData.successfulUses)
            );
          }
        }
      }
    }
    for (const spellData of saveGame.spells) {
      const spell = this.spells[spellData.name as SpellName];
      if (spell) {
        spell.uses$.next(new Decimal(spellData.uses as Decimal));
        spell.successfulUses$.next(
          new Decimal(spellData.successfulUses as Decimal)
        );
        spell.consecutiveUses$.next(
          new Decimal(spellData.maxConsecutiveUses as Decimal)
        );
        spell.consecutiveUses$.next(new Decimal(new Decimal(0)));
        spell.secret = spellData.secret;
        spell.new = spellData.new;
        spell.unlocked = spellData.unlocked;
        spell.toggleHiddenByPlayer(spellData.hiddenByPlayer);
        spell.currentCooldown = new Decimal(spellData.currentCooldown);
        for (const optionData of spellData.optionsData ?? []) {
          if (optionData.name in spell.optionsData) {
            spell.optionsData[optionData.name].unlocked = optionData.unlocked;
            spell.optionsData[optionData.name].uses$.next(
              new Decimal(optionData.uses)
            );
            spell.optionsData[optionData.name].successfulUses$.next(
              new Decimal(optionData.successfulUses)
            );
          }
        }
      }
    }
    this.batches = {};
    for (const batchData of saveGame.batches) {
      const batch = document.createElement('ri-batch');
      if (batch) {
        batch.name = batchData.name;
        batch.displayName = batchData.displayName;
        batch.uses$.next(new Decimal(batchData.uses));
        batch.toggleHiddenByPlayer(batchData.hiddenByPlayer);
        batch.activityQueue = batchData.activityQueue.map((queueItemData) => {
          const queueItem = document.createElement(
            'ri-activity-queue-item'
          ) as ActivityQueueItem;
          if (queueItemData.name in this.activities)
            queueItem.activity =
              this.activities[queueItemData.name as ActivityName];
          else if (queueItemData.name in this.spells)
            queueItem.activity = this.spells[queueItemData.name as SpellName];
          else if (queueItemData.name in this.batches)
            queueItem.activity = this.batches[queueItemData.name];
          else
            setTimeout(() => {
              queueItem.activity = this.batches[queueItemData.name];
            });
          queueItem.repeat = queueItemData.repeat;
          queueItem.activeIndex = queueItemData.activeIndex;
          if (queueItemData.option in queueItem.activity.optionsData) {
            queueItem.option = queueItemData.option;
          } else {
            queueItem.option = queueItem.activity.options[0];
          }
          return queueItem;
        });
        batch.activityQueueIndex = batchData.activityQueueIndex;
      }
      ri.batches[batch.name] = batch;
    }
    this.activityQueue = [];
    for (const queueItemData of saveGame.loadouts[
      [undefined, -1].includes(saveGame.selectedLoadoutIndex)
        ? 0
        : saveGame.selectedLoadoutIndex
    ]) {
      const queueItem = document.createElement(
        'ri-activity-queue-item'
      ) as ActivityQueueItem;
      if (queueItemData.name in this.activities)
        queueItem.activity =
          this.activities[queueItemData.name as ActivityName];
      else if (queueItemData.name in this.spells)
        queueItem.activity = this.spells[queueItemData.name as SpellName];
      else if (queueItemData.name in this.batches)
        queueItem.activity = this.batches[queueItemData.name];
      else
        throw new Error(
          'Unknown activity, spell, or batch: ' + queueItemData.name
        );
      queueItem.repeat = queueItemData.repeat;
      queueItem.repeatActivity = queueItemData.repeatActivity;
      queueItem.activeIndex = queueItemData.activeIndex;
      queueItem.option = queueItemData.option ?? queueItem.activity.options[0];
      this.activityQueue.push(queueItem);
    }
    if (!ri.activityQueue.some((queueItem) => queueItem.repeat > 0)) {
      const restQueueItem = document.createElement(
        'ri-activity-queue-item'
      ) as ActivityQueueItem;
      restQueueItem.activity = ri.activities.rest;
      restQueueItem.repeat = 1;
      ri.activityQueue.push(restQueueItem);
    }
    for (const i in this.loadouts) {
      // Reset the loadout to default
      this.loadouts[i] = [];
      // Add the queues to the loadout
      if (saveGame.loadouts?.[i]) {
        for (const queueItemData of saveGame.loadouts[i]) {
          const queueItem = document.createElement(
            'ri-activity-queue-item'
          ) as ActivityQueueItem;
          if (queueItemData.name in this.activities)
            queueItem.activity =
              this.activities[queueItemData.name as ActivityName];
          else if (queueItemData.name in this.spells)
            queueItem.activity = this.spells[queueItemData.name as SpellName];
          else if (queueItemData.name in this.batches)
            queueItem.activity = this.batches[queueItemData.name];
          else
            throw new Error(
              'Unknown activity, spell, or batch: ' + queueItemData.name
            );
          queueItem.repeat = queueItemData.repeat;
          queueItem.repeatActivity = queueItemData.repeatActivity;
          queueItem.activeIndex = queueItemData.activeIndex;
          queueItem.option =
            queueItemData.option ?? queueItem.activity.options[0];
          this.loadouts[i].push(queueItem);
        }
      }
    }
    this.lastLoadoutIndex = saveGame.selectedLoadoutIndex;
    this.activityQueueIndex = saveGame.activityQueueIndex;

    ri.seenEntries = new Set(saveGame.seenEntries);
    ri.actors = [
      ...saveGame.actors.creatures.map(Creature.fromJSON),
      ...saveGame.actors.spawners.map(Spawner.fromJSON),
      ...saveGame.actors.other.map(Actor.fromJSON),
    ];

    function logEntryFromSave(
      entryData: LogEntrySaveData | ActivityLogEntrySaveData
    ) {
      if ('cost' in entryData || 'effect' in entryData) {
        entryData = entryData as ActivityLogEntrySaveData;
        const activityLogEntry = document.createElement(
          'ri-activity-log-entry'
        );
        activityLogEntry.name = entryData.name;
        activityLogEntry.displayName = entryData.displayName;
        activityLogEntry.cost = new Map(entryData.cost);
        activityLogEntry.effect = new Map(entryData.effect);
        activityLogEntry.logString = entryData.logString;
        activityLogEntry.tick = entryData.tick;
        activityLogEntry.tags = new Set(entryData.tags);
        return activityLogEntry;
      }
      const logEntry = document.createElement('ri-log-entry');
      logEntry.msg = entryData.msg;
      logEntry.tick = entryData.tick;
      logEntry.tags = new Set(entryData.tags);
      return logEntry;
    }
    if (saveGame.log) {
      this.logEntries = saveGame.log.map((entry) => logEntryFromSave(entry));
    }
    if (saveGame.settings) {
      mergeDeep(ri.settings, saveGame.settings);
    }
    // Set position last, as this will push a value to ri.position$
    this.position = new Vector(
      saveGame?.position?.[0] ?? 0,
      saveGame?.position?.[1] ?? 0,
      saveGame?.position?.[2] ?? 0
    );
    this.readyToSave = false;
  }

  public loadPanels(
    panels: Record<
      string,
      {
        pinned: boolean;
        width: string;
        height: string;
        top: string;
        left: string;
      }
    > = ri.defaultPanels,
    old = false
  ) {
    if (!ri.masonryRoot) {
      ri.masonryRoot =
        ri.shadowRoot?.getElementById('masonry-root') ?? undefined;
      if (!ri.masonryRoot) return;
    }
    for (const [id, panel] of Object.entries(panels)) {
      const panelElement = ri.shadowRoot?.getElementById(id) as Panel;
      if (panelElement) {
        const horizontalStep = Math.round(ri.masonryRoot.offsetWidth / 10);
        const verticalStep = Math.round(ri.masonryRoot.offsetHeight / 10);
        panelElement.style.width = panel.width;
        panelElement.style.height = panel.height;
        panelElement.style.top = panel.top;
        panelElement.style.left = panel.left;
        // setTimeout(() => {
        // const computedStyles = window.getComputedStyle(panelElement);
        // panelElement.style.width = computedStyles.width;
        // panelElement.style.height = computedStyles.height;
        // panelElement.style.top = computedStyles.top;
        // panelElement.style.left = computedStyles.left;
        panelElement.style.width = `${roundToSteps(
          panelElement.offsetWidth,
          horizontalStep
        )}px`;
        panelElement.style.height = `${roundToSteps(
          panelElement.offsetHeight,
          verticalStep
        )}px`;
        panelElement.style.top = `${roundToSteps(
          panelElement.offsetTop,
          verticalStep
        )}px`;
        panelElement.style.left = `${roundToSteps(
          panelElement.offsetLeft,
          horizontalStep
        )}px`;
        panelElement.requestUpdate();
        panelElement.togglePin(panel.pinned);
        if (old) panelElement.new = false;
        // }, 100);
      }
    }
    // ri.masonry?.shiftLayout();
  }

  /**
   * Logs a message to the in-game log.
   * @param msg The message to log.
   * @param tags What tags should this log entry have?
   */
  public log(msg: string, tags: Set<string> | string[] = new Set()) {
    tags = new Set(tags);
    const logEntry = document.createElement('ri-log-entry');
    logEntry.msg = msg;
    logEntry.tick = ri.tick;
    logEntry.life = this.life;
    logEntry.tags = tags;
    ri.logString += `${ri.tick}:[${[...tags].join(',')}]:${msg}\n`;
    ri.logEntries$.next([logEntry, ...this.logEntries]);
    if (this.logEntries.length > 200) {
      this.shortenLogEntries();
    }
    this.shadowRoot?.querySelector('ri-log')?.requestUpdate();
    document.querySelector('ri-settings')?.requestUpdate();
  }

  /**
   * Logs a event, such as an Activity being used, with a cost and effect pair to the in-game log.
   * @param param0 What is the entry about?
   * @param logString An extra string to preface the entry.
   * @param cost What did the event cost?
   * @param effect What effect did the event have?
   * @param tags What tags should this log entry have?
   */
  public logCostEffect(
    {name, displayName}: Named,
    logString: string,
    cost: Cost,
    effect: Cost,
    tags: Set<string> | string[] = new Set()
  ) {
    const lastEntry = this.logEntries[0] as ActivityLogEntry;
    const mergeID = name;
    if (lastEntry?.mergeID === mergeID) {
      lastEntry.add({
        cost,
        effect,
      });
      ri.logString = ri.logString.slice(0, -1) + '+\n';

      return;
    }
    const activityLogEntry = document.createElement('ri-activity-log-entry');
    activityLogEntry.name = name;
    activityLogEntry.displayName = displayName;
    activityLogEntry.cost = cost;
    activityLogEntry.effect = effect;
    activityLogEntry.tick = this.tick;
    activityLogEntry.life = this.life;
    activityLogEntry.mergeID = mergeID;
    activityLogEntry.tags = new Set([
      ...tags,
      name,
      ...cost.keys(),
      ...effect.keys(),
    ]);
    ri.logString += `${ri.tick}:[${[...activityLogEntry.tags].join(
      ','
    )}]:${Array.from(cost.entries()).map(
      ([k, v]) => `${k}: ${v.value}`
    )}, ${Array.from(effect.entries()).map(([k, v]) => `${k}: ${v.value}`)}\n`;
    // TODO Dedupe this
    this.logEntries.unshift(activityLogEntry);
    if (this.logEntries.length > 200) {
      this.shortenLogEntries();
    }
    this.shadowRoot?.querySelector('ri-log')?.requestUpdate();
    (document.querySelector('ri-settings') as Settings).requestUpdate();
  }

  /** Cache of what points have what tags. */
  pointTagCache = new Map<string, boolean>();
  /**
   * Horrifyingly inefficient. Checks if a point is in a landmark with a given tag.
   * @param point
   * @param tag
   * @returns
   */
  public pointHasTag(point: Vector, tag: string): boolean {
    const key = `${new Vector(
      point.x.round(),
      point.y.round(),
      point.x.round()
    ).toString()}-${tag}`;
    if (!this.pointTagCache.has(key)) {
      this.pointTagCache.set(
        key,
        Object.values(ri.landmarks).some(
          (landmark) =>
            (landmark.tags.has(tag) && landmark.hasTagsAt(point)) ||
            (landmark.centralTags.has(tag) && landmark.shape.contains(point))
        )
      );
    }
    return this.pointTagCache.get(key)!;
  }

  public reincarnate() {
    this.log(
      'Suddenly, you find yourself back at the portal. You remember some things from your past lives that might make your life easier.'
    );
    for (const unlockable of this.unlockables) {
      if (!unlockable.persistentUnlock) {
        unlockable.unlocked = false;
      }
      if (!unlockable.persistentValue) {
        if (unlockable instanceof ValuefulUnlockableLitElement) {
          // unlockable.resetToInitials();
        }
      }
    }
    this.life += 1;
    this.tick$.next(new Decimal(0));
    this.position$.next(new Vector(0, 0));
    this.distance = new Decimal(0);
  }

  public removeStatusEffect(statusEffect: StatusEffect) {
    this.statusEffects = this.statusEffects.filter((s) => s !== statusEffect);
    ri.getPanel('activity-queue').requestUpdate();
  }
  backgroundColor: typeof Color = new Color('#66ccff');
  originalBackgroundColor: typeof Color = new Color('#66ccff');

  public override render() {
    // This is delicate, relies on no one else changing global_css
    // Also extremenly expensive cause of layout.
    // Two weeks later and I have no idea how this works, comment your code
    // let backgroundColor = new Color('#8fdaff');// this.backgroundColor.hwb.h = amount.toNumber() % 255;

    // let backgroundColor = new Color('#e4ece5');
    let refresh = false;

    if (this.lastDarkMode != this.settings.darkMode) {
      refresh = true;
      this.lastDarkMode = this.settings.darkMode;
      if (this.settings.darkMode) {
        this.backgroundColor = new Color('#00111a');
      } else {
        this.backgroundColor = this.originalBackgroundColor;
      }
    }
    if (this.lastLightEffects != this.settings.lightEffects) {
      refresh = true;
      this.lastLightEffects = this.settings.lightEffects;
    }

    if (
      refresh ||
      !this.resources.light.value.eq(this.lastLightValue) ||
      !this.backgroundColor.equals(this.originalBackgroundColor)
    ) {
      if (insertedCSS) global_css.styleSheet?.deleteRule(0);
      if (ri.settings.lightEffects) {
        this.backgroundColor.hwb.w *= this.resources.light.value
          .div(100)
          .plus(1)
          .toNumber();
        this.backgroundColor.hwb.b *= this.resources.light.value
          .div(100)
          .times(-1)
          .plus(1)
          .toNumber();
        this.backgroundColor.lch.c *= this.resources.light.value
          .div(100)
          .div(3)
          .plus(1)
          .toNumber();
        this.backgroundColor.lch.l *= this.resources.light.value
          .div(100)
          .div(3)
          .plus(1)
          .toNumber();
      }
      const maxColorComponent = Math.max(
        this.backgroundColor.r,
        this.backgroundColor.g,
        this.backgroundColor.b,
        1
      );
      global_css.styleSheet?.insertRule(
        `*{--background-color: ${(
          (this.backgroundColor.r * 255) /
          maxColorComponent
        ).toFixed(0)} ${(
          (this.backgroundColor.g * 255) /
          maxColorComponent
        ).toFixed(0)} ${(
          (this.backgroundColor.b * 255) /
          maxColorComponent
        ).toFixed(0)};}`,
        0
      );
      insertedCSS = true;
    }
    this.lastLightValue = this.resources.light.value;
    return html`
      <div id="masonry-root">
        <ri-speed-controls></ri-speed-controls>
        <ri-resources></ri-resources>
        <ri-resources-delta></ri-resources-delta>
        <ri-stats></ri-stats>
        <ri-activities></ri-activities>
        <ri-activity-queue
          .name=${`Queue${
            this.editingBatch
              ? ` - EDITING BATCH ${this.editingBatch.displayName}`
              : ''
          }`}
        ></ri-activity-queue>
        <ri-batches></ri-batches>
        <ri-log></ri-log>
        <ri-unlockables></ri-unlockables>
        <ri-map> </ri-map>
        <ri-landmarks></ri-landmarks>
        <ri-spells></ri-spells>
        <ri-dev-tools> </ri-dev-tools>
        <!-- ${this.isDev
          ? html`<ri-creature-editor></ri-creature-editor>`
          : nothing} -->
        <ri-panel id="panel-management" .name=${'Panels'}>
          <select id="closed-panels-select">
            ${ri.panels
              .filter((panel) => panel.hasAttribute('closed'))
              .map((panel) => {
                return html`<option value=${panel.id}>
                  ${panel.displayName}
                </option>`;
              })}
          </select>
          <button
            @click=${() => {
              ri.getPanel(
                ((
                  this.shadowRoot?.getElementById('closed-panels-select') as
                    | HTMLInputElement
                    | undefined
                )?.value as PanelID | undefined) ?? 'panel-management'
              ).toggleAttribute('closed', false);
            }}
          >
            Add Panel
          </button>
          <button
            @click=${() => {
              ri.panels?.forEach((panel) => {
                if (panel instanceof Panel) {
                  panel.isBeingEdited = !panel.isBeingEdited;
                }
              });
              this.requestUpdate();
            }}
          >
            ${(this.shadowRoot?.querySelector('ri-panel') as Panel)
              ?.isBeingEdited
              ? 'Hide'
              : 'Show'}
            Panel Editing Tools
          </button>
          <!-- <button
            @click=${() => {
            for (const panel of (ri.shadowRoot?.querySelectorAll(
              'ri-panel'
            ) as NodeListOf<Panel>) ?? []) {
              panel.togglePin(false);
            }
          }}
          >
            Unpin All
          </button> -->
          <button
            @click=${() => {
              ri.loadPanels();
            }}
          >
            Reset Layout
          </button>
        </ri-panel>
      </div>
    `;
  }

  public resetSave() {
    localStorage.removeItem('saveGame');
    localStorage.removeItem('panels');
    this.readyToSave = false;
    window.location.reload();
  }

  canvasDimensions: [number, number] = [0, 0];
  public resizeMapCanvas(dimensions: [number, number]): void {
    ri.canvasDimensions = dimensions;
    ri.p5?.resizeCanvas(...dimensions);
    ri.overlay?.resizeCanvas(...dimensions);
  }

  public set(name: Gettable, value: DecimalSource): Decimal {
    // console.log(`Setting ${value} ${name}`);
    if (name.slice(-9) == ':capacity') {
      const item = this.get(name.slice(0, -9) as ResourceName);
      if (!item)
        throw new Error(
          `${name} is not gettable, don't even think about its capacity.`
        );
      if (item.baseCapacity) {
        item.baseCapacity = new Decimal(value);
        return item.baseCapacity;
      }
      throw new Error(
        `${name} does not have a capacity property. Are you sure it's a Resource?`
      );
    }
    if (name === 'distance') {
      this.distance = new Decimal(value);
      return this.distance;
    }
    if (name in this.resources) {
      return this.resources[name as ResourceName].setValue(new Decimal(value));
    }
    if (name in this.stats) {
      return this.stats[name as StatName].setValue(new Decimal(value));
    }
    throw new Error(`No such resource or stat: ${name}`);
  }

  public shortenLogEntries(options = {strict: true, change: true}) {
    const newEntries = this.logEntries
      .filter((entry) => options.strict && !entry.tags.has('persistent'))
      .slice(0, 100)
      .concat(
        this.logEntries.filter(
          (entry) => !options.strict || entry.tags.has('persistent')
        )
      );
    if (options.change) this.logEntries = newEntries;
    return this.logEntries;
  }

  public dealDamage(defender: Entity) {
    const damage = this.stats.strength.value;
    ri.log(
      `Deal ${damage} damage to ${
        defender.name
      } => ${defender.resources.health?.value?.minus(damage)}/${
        defender.resources.health?.capacity
      }`,
      ['combat']
    );
    defender.takeDamage(damage, this);
  }
  kill(victim: Entity) {
    // Give attacker loot
    for (const [name, amount] of victim.loot) {
      this.gain(name, amount);
    }
    this.kills[victim.name] = (this.kills[victim.name] ?? 0) + 1;
  }

  public takeDamage(damage: Decimal, attacker: Entity | Landmark) {
    // console.log('takeDamage', damage, attacker.name, 'to', this.name);
    ri.log(`Take ${damage} damage from ${attacker.name}`, ['combat']);
    this.resources.health.addValue(damage.negate());
  }

  public toJSON() {
    return {
      version: saveVersion,
      life: ri.life,
      tick: ri.tick$.value,
      lastTime: ri.lastTime,
      lastSpellCooldownTime,
      distance: ri.distance,
      position: ri.position.toJSON(),
      unlockedPanels: Array.from(ri.unlockedPanels),
      logString: ri.logString,
      resourcesFilters: Array.from(
        ri.shadowRoot?.querySelector('ri-resources')?.filters ?? []
      ),
      activitiesFilters: Array.from(
        ri.shadowRoot?.querySelector('ri-activities')?.filters ?? []
      ),
      spellsFilters: Array.from(
        ri.shadowRoot?.querySelector('ri-spells')?.filters ?? []
      ),
      unlockablesFilters: Array.from(
        ri.shadowRoot?.querySelector('ri-unlockables')?.filters ?? [
          'landmark',
          'spell',
          'activity',
          'activity-option',
          'resource',
          'stat',
          'unlocked',
        ]
      ),
      logFilters: Array.from(
        ri.shadowRoot?.querySelector('ri-log')?.filters ?? []
      ),
      landmarks: Object.values(ri.landmarks).map((landmark: Landmark) =>
        landmark.toJSON()
      ),
      nextLandmark: ri.nextLandmark?.name ?? null,
      targetPosition: ri.targetPosition.toJSON(),
      resources: Object.values(ri.resources).map((resource: Resource) =>
        resource.toJSON()
      ),
      activities: Object.values(ri.activities).map((activity: Activity) =>
        activity.toJSON()
      ),
      batches: Object.values(ri.batches).map((batch: Batch) => batch.toJSON()),
      spells: Object.values(ri.spells).map((spell: Spell) => spell.toJSON()),
      stats: Object.values(ri.stats).map((stat: Stat) => stat.toJSON()),
      loadouts: ri.loadouts.map((loadout: ActivityQueueItem[], i) => {
        if (ri.lastLoadoutIndex == i) {
          return ri.activityQueue.map((queueItem: ActivityQueueItem) => ({
            name: queueItem.activity.name,
            repeat: queueItem.repeat,
            repeatActivity: queueItem.repeatActivity,
            activeIndex: queueItem.activeIndex,
            option: queueItem.option,
          }));
        }
        return loadout.map((queueItem) => ({
          name: queueItem.activity.name,
          repeat: queueItem.repeat,
          repeatActivity: queueItem.repeatActivity,
          activeIndex: queueItem.activeIndex,
          option: queueItem.option,
        }));
      }),
      selectedLoadoutIndex: ri.lastLoadoutIndex,
      activityQueueIndex: ri.activityQueueIndex,
      log: ri
        .shortenLogEntries({strict: true, change: false})
        .map(
          (logEntry: LogEntry): LogEntrySaveData | ActivityLogEntrySaveData => {
            if (logEntry instanceof ActivityLogEntry) {
              return {
                name: logEntry.name,
                displayName: logEntry.displayName,
                cost: [...logEntry.cost.entries()],
                effect: [...logEntry.effect.entries()],
                logString: logEntry.logString,
                tags: Array.from(logEntry.tags),
                tick: logEntry.tick,
              };
            }
            return {
              msg: logEntry.msg,
              tags: Array.from(logEntry.tags),
              tick: logEntry.tick,
            };
          }
        ),
      kills: ri.kills,
      settings: ri.settings,
      seenEntries: [...ri.seenEntries],
      actors: {
        creatures: Object.values(ri.actors)
          .filter((a) => a instanceof Creature)
          .map((actor: Actor) => actor.toJSON()),
        spawners: Object.values(ri.actors)
          .filter((a) => a instanceof Spawner)
          .map((actor: Actor) => actor.toJSON()),
        other: Object.values(ri.actors)
          .filter((a) => !(a instanceof Creature || a instanceof Spawner))
          .map((actor: Actor) => actor.toJSON()),
      },
    };
  }

  public togglePause(pause?: boolean) {
    if (pause === undefined) {
      if (this.gameSpeed === 0) this.gameSpeed = 1;
      else if (this.gameSpeed === 1) this.gameSpeed = 0;
    } else {
      this.gameSpeed = pause ? 0 : 1;
    }
    if (this.gameSpeed === 0) {
      ri.masonryRoot?.classList.add('paused');
    } else {
      ri.masonryRoot?.classList.remove('paused');
    }
  }

  /** Unlocks a game feature panel */
  public unlockPanel(panelId: PanelID) {
    // console.log(`Unlocking Panel ${panelId}`);
    const panel = this.shadowRoot?.getElementById(panelId);
    if (!(panel instanceof Panel)) return;
    if (!this.unlockedPanels.has(panelId)) {
      panel.addEventListener('mouseover', () => {
        panel.classList.remove('new');
      });
      this.unlockedPanels.add(panelId);
      panel.shadowRoot?.querySelector('help-icon')?.tooltip.show();
    }
    const panelsString = localStorage.getItem('panels');
    let panels;
    let useDefaultPanel = true;
    // if (panelsString) {
    //   panels = JSON.parse(panelsString);
    //   if (
    //     panelId !== 'panel-management' &&
    //     panelId in panels &&
    //     panels[panelId].width !== '0px'
    //   ) {
    //     useDefaultPanel = false;
    //   }
    // }

    if (useDefaultPanel) {
      this.loadPanels({[panelId]: ri.defaultPanels[panelId]});
    } else {
      this.loadPanels({[panelId]: panels[panelId]});
    }
    if (!this.isDragging) {
      this.masonry?.shiftLayout();
    }
  }

  public unlockPerceptionMinigame() {
    setClickMeStartDate(Date.now());
    document
      .getElementById('perception-click-target')!
      .removeAttribute('hidden');
  }

  public updateMap() {
    const map = this.getPanel('map');
    const canvas = map.shadowRoot?.getElementById('map-canvas');
    if (!canvas) return;
    if (!this.mapInitialized) {
      this.mapInitialized = true;
      //TODO no more typeof below
      // @ts-expect-error: p5 is acting weird // HACK
      ri.p5 = new p5(setupP5(map), canvas); // invoke p5
    }
  }

  public updateNextLandmark(): void {
    // Update nextLandmark
    const landmarkSelectEl = ri
      .getPanel('landmarks')
      .shadowRoot?.getElementById('destination-select') as HTMLSelectElement;
    if (landmarkSelectEl === null) return;
    const landmarkName = landmarkSelectEl.value;
    ri.nextLandmark = ri.landmarks[landmarkName];
  }

  // #endregion Public Methods (38)
}
